import { useDispatch, useSelector } from "react-redux";
import { WarningIcon } from "../../icons";
import { deleteScenario } from "../../store/slices/simulateSlice";
import { CancelBtn, DeleteBtn, DeleteScenario } from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { Modal } from "../CommonUIComponents/Modal/Modal";

function ModalBody() {
  return (
    <span className="view-endagement-delete-modal-body">
      {
        "Are you sure you want to delete this scenario? Please note that once deleted, it cannot be recovered."
      }
    </span>
  );
}

function ModalFooter({ handleCancelClick, onConfirm }) {
  return (
    <div className="view-endagement-delete-modal-footer">
      <Button variant="secondary" onClick={handleCancelClick}>
        {CancelBtn}
      </Button>
      <Button onClick={onConfirm} variant="primary">
        {DeleteBtn}
      </Button>
    </div>
  );
}

export function SimulateDeleteModal({
  isModalVisible,
  onClose,
  projectToDelete,
}) {
  const dispatch = useDispatch();
  const engagement = useSelector((state) => state.engagement.engagement);

  function onConfirm() {
    dispatch(
      deleteScenario({
        engagementCode: engagement.engagementCode,
        scenarioId: projectToDelete,
      })
    );
    onClose();
  }

  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={
        <div className="file-version-history-modal-header">
          <div className="motif-fab">
            <WarningIcon />
          </div>
          <span>{DeleteScenario}</span>
        </div>
      }
      body={<ModalBody />}
      footer={<ModalFooter handleCancelClick={onClose} onConfirm={onConfirm} />}
    />
  );
}
